import { Component, TemplateRef, ViewChild, AfterViewInit, ElementRef, HostListener, PLATFORM_ID, Inject, ChangeDetectorRef } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

import { TranslateService } from '@ngx-translate/core';
import { SwapStatus, convertNum, getParamWithoutCookie } from '../../shared/constants/app-enums';
import { environment } from '../../../environments/environment';
import { ClaimComponent } from '../../modals/claim/claim.component';
import { ConnectComponent } from '../../modals/connect/connect.component';
import { PopupService } from '../../services/popup.service';
import { WalletConnectService } from '../../services/wallet-connect.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { isPlatformBrowser } from '@angular/common';

interface IReward {
  name: string;
  value: number;
}

@Component({
  selector: 'app-staking',
  templateUrl: './staking.component.html',
  styleUrls: ['./staking.component.scss'],
})
export class StakingComponent implements AfterViewInit {
  @ViewChild('graphCont') graphCont!: ElementRef;

  rewards: IReward[] = [
    {
      name: 'Jul-2025', //1
      value: 195203344116,
    },
    {
      name: 'Aug-2025', //2
      value: 195860594432,
    },
    {
      name: 'Sep-2025', //3
      value: 196517844749,
    },
    {
      name: 'Oct-2025', //4
      value: 197175095066,
    },
    {
      name: 'Nov-2025', //5
      value: 197832345383,
    },
    {
      name: 'Dec-2025', //6
      value: 198489595700,
    },
    {
      name: 'Jan-2026', //7
      value: 199146846017,
    },
    {
      name: 'Feb-2026', //8
      value: 199804096334,
    },
    {
      name: 'Mar-2026', //9
      value: 200461346651,
    },
    {
      name: 'Apr-2026', //10
      value: 201118596968,
    },
    {
      name: 'May-2026', //11
      value: 201775847284,
    },
    {
      name: 'Jun-2026', //12
      value: 202433097601,
    },
    {
      name: 'Jul-2026', //13
      value: 203090347918,
    },
    {
      name: 'Aug-2026', //14
      value: 203747598235,
    },
    {
      name: 'Sep-2026', //15
      value: 204404848552,
    },
    {
      name: 'Oct-2026', //16
      value: 205062098869,
    },
    {
      name: 'Nov-2026', //17
      value: 205719349186,
    },
    {
      name: 'Dec-2026', //18
      value: 206376599503,
    },
    {
      name: 'Jan-2027', //19
      value: 207033849820,
    },
    {
      name: 'Feb-2027', //20
      value: 207691100136,
    },
    {
      name: 'Mar-2027', //21
      value: 208348350453,
    },
    {
      name: 'Apr-2027', //22
      value: 209005600770,
    },
    {
      name: 'May-2027', //23
      value: 209662851087,
    },
    {
      name: 'Jun-2027', //24
      value: 210320101404,
    },
  ];

  fitContainer: boolean = true;
  view: [number, number] = [400, 200];
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  legendTitle: string = 'Total Rewards';
  legendPosition: string = 'below'; // ['right', 'below']
  showLegend = false;
  showXAxisLabel = true;
  xAxisLabel = 'Months';
  showYAxisLabel = true;
  yAxisLabel = 'Supply';
  SwapStatus = SwapStatus;
  showGridLines: boolean = true;
  showDataLabel: boolean = false;
  pageLoaded: boolean = false;
  maxYAxis = 100;
  minYAxis = 0;
  stakeUnlockTime: number = environment.stakeUnlockTime;
  stakeAmount!: number;
  colorScheme: Color = {
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
    ],
  };

  lang: string = '';
  timeInterval!: ReturnType<typeof setInterval>;
  cryptoName: string = environment.tokenName;

  walletAddress!: string;
  stakeData = this.walletConnectService.stakeData;
  userStaked: string = '0';
  poolPercent: number = 0;
  ethClaimable: any = 0;
  ethTokens: number = 0;

  userReward: string = '0';
  totalStaked: string = '0';
  userBal: number = 0;
  userBalString: string = '0';

  unstakeDate!: Date;
  canUnstake!: boolean;
  hash!: string;
  status!: SwapStatus;
  isWert: boolean = false;
  isClaimActive: boolean = false;
  bwUrl: any;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.view = [+this.graphCont.nativeElement.offsetWidth / 1.05, 400];
  }

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private popupService: PopupService,
    private translate: TranslateService,
    private walletConnectService: WalletConnectService,
    private modalRef: BsModalRef,
    private modalService: BsModalService,
    private cdRef: ChangeDetectorRef,
  ) {
    let diff = 0;
    const date = new Date();
    const today = date.getUTCDate();
    const currMon = date.getUTCMonth();
    const currYear = date.getUTCFullYear();

    this.rewards.forEach((item: IReward, index: number) => {
      const itemDate = new Date(item.name);
      itemDate.setDate(itemDate.getDate() + 10);
      const itemMon = itemDate.getUTCMonth();
      const itemYear = itemDate.getUTCFullYear();
      if (itemYear === currYear && itemMon === currMon) {
        diff = index;
      }
    });

    this.colorScheme.domain[diff] = '#98FF19';
    if (isPlatformBrowser(this._platformId)) setInterval(() => this.updateAllgetMethod(), 500);
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    if (isPlatformBrowser(this._platformId)) {
      this.pageLoaded = true;
      setTimeout(() => (this.view = [+this.graphCont.nativeElement.offsetWidth / 1.05, 400]), 500);
      this.cdRef.detectChanges();
      this.bwUrl = getParamWithoutCookie('bwUrl');
    }
  }

  updateAllgetMethod(): void {
    this.walletAddress = this.walletConnectService.walletAddress;
    this.stakeData = this.walletConnectService.stakeData;
    this.userStaked = this.walletAddress ? this.formatNumber(+this.stakeData.userStaked.toFixed(0)) : '0';
    this.poolPercent = this.walletAddress && this.stakeData.totalStaked !== 0 ? +((this.stakeData.userStaked * 100) / this.stakeData.totalStaked).toFixed(5) || 0 : 0;
    this.userReward = this.walletAddress ? this.formatNumber(+this.stakeData.userReward.toFixed(0)) : '0';
    this.ethClaimable = this.walletAddress ? this.formatNumber(+this.walletConnectService.balanceData.ethClaimable!.toFixed(0)) : 0;
    this.ethTokens = this.walletAddress ? (this.walletConnectService.balanceData?.ethClaimable ?? 0) : 0;
    this.totalStaked = this.formatNumber(+this.stakeData.totalStaked.toFixed(0));
    this.userBalString = this.formatNumber(this.stakeData.userBal);
    this.userBal = this.stakeData.userBal;
    this.unstakeDate = new Date(this.stakeData.unlockTime * 1000);
    this.unstakeDate = this.unstakeDate.getTime() > this.stakeUnlockTime ? new Date(this.unstakeDate) : new Date(this.stakeUnlockTime);
    this.canUnstake = this.unstakeDate < new Date();
    this.hash = this.walletConnectService.swapHash;
    this.status = this.walletConnectService.swapStatus;
  }

  checkEthChain() {
    if (!this.walletAddress) {
      this.connectModal();
      return false;
    }
    if (this.walletConnectService.isEthChain()) {
      return true;
    } else {
      this.popupService
        .messagePopup({
          icon: 'info',
          title: this.translate.instant('popup.change_network'),
          desc: this.translate.instant('popup.wrong_chain', { chainName: environment.eth.chainName }),
          confirmBtnTxt: this.translate.instant('misc.ok'),
        })
        .subscribe({
          next: (res: boolean) => {
            if (res) {
              this.walletConnectService.switchNetwork(environment.eth.chainIdInt);
            }
          },
        });
      return false;
    }
  }

  openModal(template: TemplateRef<void>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
    });
  }

  buyClaimStake(template: TemplateRef<void>): void {
    if (isPlatformBrowser(this._platformId)) {
      if (!this.checkEthChain()) {
        this.timeInterval = setInterval(() => this.startConnectInterval(template), 2000);
      } else if (this.walletAddress && this.ethTokens == 0) {
        this.openModal(template);
      }
    }
  }

  startConnectInterval(template: TemplateRef<void>) {
    if (this.walletAddress && this.walletConnectService.isEthChain()) {
      this.openModal(template);
      clearInterval(this.timeInterval);
    }
  }

  claimAndStake(): void {
    if (this.ethTokens > 0 && this.checkEthChain()) {
      this.modalRef = this.modalService.show(ClaimComponent, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
        initialState: { isStake: true },
      });
      this.walletConnectService.claimAndStake(+this.ethTokens);
    }
  }

  closeModal() {
    this.modalRef!.hide();
  }

  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);

  yAxisTickFormatting(value: number) {
    return this.formatNumber(value / 1000000000) + 'M'; // this is where you can change the formatting
  }

  formatString(input: string): string {
    return input.toUpperCase();
  }

  formatNumber(input: number) {
    return convertNum(input);
  }

  withdrawStake(): void {
    if (isPlatformBrowser(this._platformId)) {
      if (this.stakeData.userStaked == 0 || !this.checkEthChain()) return;
      this.modalRef!.hide();
      setTimeout(() => {
        this.modalRef = this.modalService.show(ClaimComponent, {
          class: 'modal-xs modal-dialog-centered',
          backdrop: 'static',
          initialState: { isWithdraw: true },
        });
      }, 500);
      this.walletConnectService.withdrawStake();
    }
  }

  harvestRewards(): void {
    if (isPlatformBrowser(this._platformId)) {
      if (!this.stakeData.isClaimEnabled) {
        this.popupService.messagePopup({ icon: 'info', desc: this.translate.instant('popup.claim_not_live'), confirmBtnTxt: this.translate.instant('misc.ok') });
        return;
      }
      if (this.stakeData.userReward > 0 && this.checkEthChain()) {
        this.walletConnectService.harvestRewards();
        this.modalRef?.hide();
        setTimeout(() => {
          this.modalRef = this.modalService.show(ClaimComponent, {
            class: 'modal-xs modal-dialog-centered',
            backdrop: 'static',
          });
        }, 500);
      }
    }
  }

  max() {
    this.stakeAmount = this.stakeData.userBal;
  }

  stakeToken(template: TemplateRef<void>): void {
    if (isPlatformBrowser(this._platformId)) {
      if (this.checkEthChain() && this.stakeAmount <= this.userBal){
        this.walletConnectService.createStake(this.stakeAmount);
        this.modalRef!.hide();
        setTimeout(() => {
          this.modalRef = this.modalService.show(template, {
            class: 'modal-xs modal-dialog-centered',
            backdrop: 'static',
          });
        }, 1000);
      }
    }
  }

  connectModal(): void {
    if (this.bwUrl && this.bwUrl !== '') {
      this.connectBestWallet();
      return;
    }
    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-min modal-dialog-centered',
      backdrop: 'static',
      initialState: { isBsNetwork: false },
    });
  }

  connectBestWallet() {
    this.walletConnectService.connectWallet('bw');
  }
  
  poolInfo() {
    this.popupService.messagePopup({ icon: 'info', desc: this.translate.instant('staking.pool_share', { rewardRate: this.stakeData.rewardPerRound }), confirmBtnTxt: this.translate.instant('misc.ok') });
  }

  viewUrl() {
    if (isPlatformBrowser(this._platformId)) {
      if (typeof window == 'undefined') return;
      const blkUrl = environment.eth.blockExplorerURL;
      window.open(blkUrl + this.hash, '_blank');
    }
  }

  messageEvent(event: boolean) {
    this.isWert = event;
  }
}
